<template>
  <div
    :class="{
      'modal-wrap': true,
      'is-relative': relative,
    }"
    v-if="
      !$root.disable_not_supported_banner &&
      notsupportbannerData &&
      Object.keys(notsupportbannerData).length > 0
    "
  >
    <div
      :class="{
        'modal-body': true,
        'pay-soft-modal':
          $root.notSupportPageType === 'payment' ||
          $root.notSupportPageType === 'software',
        'center-text': !(
          notsupportbannerData.best_available_data &&
          notsupportbannerData.best_available_data.length > 0
        ),
      }"
    >
      <div class="modal-header">
        <button class="close-btn">
          <svg
            width="35"
            height="34"
            viewBox="0 0 35 34"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clip-path="url(#clip0)">
              <path
                d="M17.5 33.9889C26.8888 33.9889 34.5 26.3828 34.5 17.0001C34.5 7.61739 26.8888 0.0112305 17.5 0.0112305C8.11116 0.0112305 0.5 7.61739 0.5 17.0001C0.5 26.3828 8.11116 33.9889 17.5 33.9889Z"
                fill="#E8321D"
              />
              <path
                d="M22.8933 25.0203L25.5225 22.3911L12.1085 8.97714L9.47933 11.6063L22.8933 25.0203Z"
                fill="white"
              />
              <path
                d="M12.1091 25.0236L25.5231 11.6096L22.8939 8.98047L9.47994 22.3944L12.1091 25.0236Z"
                fill="white"
              />
            </g>
            <defs>
              <clipPath id="clip0">
                <rect
                  width="34"
                  height="34"
                  fill="white"
                  transform="translate(0.5)"
                />
              </clipPath>
            </defs>
          </svg>
        </button>
        <template v-if="$root.notSupportPageType === 'review'">
          <p>{{ notsupportbannerData.i18n.we_are_sorry }}</p>
          <p>{{ notsupportbannerData.i18n.not_available_text }}</p>
        </template>
        <template v-else>
          <template v-if="notSupportWidth > 991">
            <p>
              {{ notsupportbannerData.i18n.we_are_sorry }}
              {{ notsupportbannerData.i18n.not_available_text }}
            </p>
          </template>
          <template v-else>
            <p>{{ notsupportbannerData.i18n.we_are_sorry }}</p>
            <p>{{ notsupportbannerData.i18n.not_available_text }}</p>
          </template>
        </template>
      </div>
      <div
        class="modal-cont"
        v-if="
          notsupportbannerData.best_available_data &&
          notsupportbannerData.best_available_data.length > 0
        "
      >
        <span class="span-h4">{{
          notsupportbannerData.i18n.best_available_text
        }}</span>
        <div class="row payment-available">
          <template v-if="$root.notSupportPageType === 'review'">
            <div
              class="col-lg-4"
              v-for="(data, index) in notSupportWidth < 576
                ? notsupportbannerData.best_available_data.slice(0, 2)
                : notsupportbannerData.best_available_data.slice(0, 4)"
              :key="index"
            >
              <div class="paymnt-card cas-card">
                <div class="paymnt-card-top">
                  <template v-if="$root.enable_cta_partner_logo">
                    <a
                      :title="data.product_name"
                      :href="getGoLink(data.go_link, data.slug)"
                      class="pay-logo partner-logo cas-link"
                      target="_blank"
                      :rel="
                        $root.change_cta_to_sponsored
                          ? 'nofollow sponsored'
                          : 'nofollow'
                      "
                    >
                      <img
                        v-if="
                          $root.notsupportassetSizes &&
                          $root.notsupportassetSizes.pro_asset_sizes
                        "
                        :src="
                          data.product_assets.filter(
                            (ele) =>
                              ele.asset_category_name ===
                              $root.notsupportassetSizes.pro_asset_sizes.medium
                          ).length > 0
                            ? data.product_assets
                                .filter(
                                  (ele) =>
                                    ele.asset_category_name ===
                                    $root.notsupportassetSizes.pro_asset_sizes
                                      .medium
                                )
                                .shift().url
                            : $root.site_url + $root.asset_path + '/failure.png'
                        "
                        height="70"
                        width="70"
                        class="partner-logo-castop-img pimg"
                        :alt="
                          getAltText(
                            data.product_name,
                            data.product_assets.filter(
                              (ele) =>
                                ele.asset_category_name ===
                                $root.notsupportassetSizes.pro_asset_sizes
                                  .medium
                            ).length > 0
                              ? data.product_assets
                                  .filter(
                                    (ele) =>
                                      ele.asset_category_name ===
                                      $root.notsupportassetSizes.pro_asset_sizes
                                        .medium
                                  )
                                  .shift().url
                              : $root.site_url +
                                  $root.asset_path +
                                  '/failure.png'
                          )
                        "
                      />
                      <div class="partner-hover wd-notsup">
                        <div
                          class="partner-hover-inner"
                          :style="{
                            '--primary-btn': $root.color_schema.primary_btn,
                            '--primary-btn-hover': pSBC(
                              -0.2,
                              $root.color_schema.primary_btn
                            ),
                          }"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="10"
                            height="16"
                            viewBox="0 0 10 16"
                            fill="none"
                          >
                            <path
                              d="M9.44469 7.37568L2.32449 0.255608C2.15981 0.090796 1.93997 0 1.70557 0C1.47116 0 1.25133 0.090796 1.08664 0.255608L0.562291 0.779831C0.22109 1.12142 0.22109 1.6766 0.562291 2.01767L6.5413 7.99668L0.555657 13.9823C0.390975 14.1471 0.300049 14.3668 0.300049 14.6011C0.300049 14.8357 0.390975 15.0554 0.555657 15.2203L1.08001 15.7444C1.24482 15.9092 1.46453 16 1.69893 16C1.93334 16 2.15317 15.9092 2.31785 15.7444L9.44469 8.61782C9.60976 8.45248 9.70043 8.23174 9.69991 7.99707C9.70043 7.7615 9.60976 7.54088 9.44469 7.37568Z"
                              fill="white"
                            />
                          </svg>
                        </div>
                      </div>
                    </a>
                  </template>
                  <template v-else>
                    <div class="pay-logo">
                      <img
                        v-if="
                          $root.notsupportassetSizes &&
                          $root.notsupportassetSizes.pro_asset_sizes
                        "
                        :src="
                          data.product_assets.filter(
                            (ele) =>
                              ele.asset_category_name ===
                              $root.notsupportassetSizes.pro_asset_sizes.medium
                          ).length > 0
                            ? data.product_assets
                                .filter(
                                  (ele) =>
                                    ele.asset_category_name ===
                                    $root.notsupportassetSizes.pro_asset_sizes
                                      .medium
                                )
                                .shift().url
                            : $root.site_url + $root.asset_path + '/failure.png'
                        "
                        height="70"
                        width="70"
                        class="partner-logo-castop-img pimg"
                        :alt="
                          getAltText(
                            data.product_name,
                            data.product_assets.filter(
                              (ele) =>
                                ele.asset_category_name ===
                                $root.notsupportassetSizes.pro_asset_sizes
                                  .medium
                            ).length > 0
                              ? data.product_assets
                                  .filter(
                                    (ele) =>
                                      ele.asset_category_name ===
                                      $root.notsupportassetSizes.pro_asset_sizes
                                        .medium
                                  )
                                  .shift().url
                              : $root.site_url +
                                  $root.asset_path +
                                  '/failure.png'
                          )
                        "
                      />
                    </div>
                  </template>
                  <template v-if="$root.enable_piwik_reload">
                    <a
                      :title="data.product_name"
                      v-if="data.review_link"
                      :href="getRouteLink(data.review_link, 'review')"
                      class="
                        pay-title
                        custom-font-1
                        text-underline text-hover
                        review-title
                      "
                      >{{
                        getPartnerGlobalString(
                          $root.i18n.review,
                          data.product_name
                        )
                      }}</a
                    >
                    <span class="pay-title custom-font-1 review-title" v-else>{{
                      data.product_name
                    }}</span>
                  </template>
                  <template v-else>
                    <router-link
                      :title="data.product_name"
                      v-if="data.review_link"
                      :to="getRouteLink(data.review_link, 'review')"
                      class="
                        pay-title
                        custom-font-1
                        text-underline text-hover
                        review-title
                      "
                      >{{
                        getPartnerGlobalString(
                          $root.i18n.review,
                          data.product_name
                        )
                      }}</router-link
                    >
                    <span class="pay-title custom-font-1 review-title" v-else>{{
                      data.product_name
                    }}</span>
                  </template>
                  <StarRating
                    :rating="parseFloat((data.rating / 2).toFixed(1))"
                  />
                </div>
                <a
                  v-if="data.go_link"
                  :title="data.product_name"
                  :href="getGoLink(data.go_link, data.slug)"
                  :class="{
                    'cta cta-primary cta-promotion custom-btn game-btn cta-large hover-btn btn-e cas-link cta-see-more': true,
                    'text-white': !getContrastYIQ(
                      $root.color_schema.primary_btn
                    ),
                    'text-gray': getContrastYIQ($root.color_schema.primary_btn),
                    'text-cta-override': $root.override_ctabtntxt_color,
                  }"
                  target="_blank"
                  :rel="
                    $root.change_cta_to_sponsored
                      ? 'nofollow sponsored'
                      : 'nofollow'
                  "
                  :style="{
                    '--primary-btn': $root.color_schema.primary_btn,
                    '--primary-btn-hover': pSBC(
                      -0.2,
                      $root.color_schema.primary_btn
                    ),
                  }"
                >
                  <span class="cta-text">{{ data.cta_button_text }}</span>
                  <span
                    class="hover-text"
                    v-for="(char, indexGo) in $root.i18n.go_to_casino"
                    :key="indexGo + `toplipp`"
                    >{{ char }}</span
                  >
                </a>
              </div>
            </div>
          </template>
          <template v-if="$root.notSupportPageType === 'payment'">
            <div
              class="col-lg-4"
              v-for="(data, index) in notSupportWidth < 576
                ? notsupportbannerData.best_available_data
                    .filter((ele) => ele.link != null)
                    .slice(0, 2)
                : notsupportbannerData.best_available_data
                    .filter((ele) => ele.link != null)
                    .slice(0, 4)"
              :key="index"
            >
              <div class="paymnt-card">
                <div class="paymnt-card-top">
                  <template v-if="$root.enable_piwik_reload">
                    <a
                      :title="data.name"
                      v-if="data"
                      :href="getRouteLink(data.link, $root.notSupportType)"
                      class="pay-title payment-title text-hover"
                    >
                      {{
                        getBPMGlobalString(
                          !data.remove_cascount &&
                            data.hasOwnProperty("toplist_count")
                            ? data.toplist_count
                            : "",
                          $root.i18n.casinos_are_supporting,
                          data.name
                        )
                      }}</a
                    >
                  </template>
                  <template v-else>
                    <router-link
                      :title="data.name"
                      v-if="data"
                      :to="getRouteLink(data.link, $root.notSupportType)"
                      class="pay-title payment-title text-hover"
                    >
                      {{
                        getBPMGlobalString(
                          !data.remove_cascount &&
                            data.hasOwnProperty("toplist_count")
                            ? data.toplist_count
                            : "",
                          $root.i18n.casinos_are_supporting,
                          data.name
                        )
                      }}</router-link
                    >
                  </template>
                  <div class="pay-logo">
                    <img
                      v-if="
                        $root.enable_lazyload &&
                        data &&
                        $root.notsupportassetSizes.pao_asset_sizes &&
                        data.asset_category_name ===
                          $root.notsupportassetSizes.pao_asset_sizes.medium
                      "
                      v-lazy="data.url"
                      :alt="getAltText(data.name, data.url)"
                      width="105"
                      height="105"
                    />
                    <img
                      v-else-if="
                        data &&
                        $root.notsupportassetSizes.pao_asset_sizes &&
                        data.asset_category_name ===
                          $root.notsupportassetSizes.pao_asset_sizes.medium
                      "
                      :src="data.url"
                      :alt="getAltText(data.name, data.url)"
                      width="105"
                      height="105"
                    />
                  </div>
                </div>
                <template v-if="$root.enable_piwik_reload">
                  <a
                    :title="data.name"
                    v-if="data"
                    :href="getRouteLink(data.link, $root.notSupportType)"
                    class="
                      cta cta-primary cta-block cta-promotion
                      custom-btn
                      hover-btn
                      cta-see-more cta-see-more-past
                    "
                    :style="{
                      '--primary-btn': $root.color_schema.primary_btn,
                      '--primary-btn-hover': pSBC(
                        -0.2,
                        $root.color_schema.primary_btn
                      ),
                    }"
                    >{{ $root.i18n.see_more }}</a
                  >
                </template>
                <template v-else>
                  <router-link
                    :title="data.name"
                    v-if="data"
                    :to="getRouteLink(data.link, $root.notSupportType)"
                    class="
                      cta cta-primary cta-block cta-promotion
                      custom-btn
                      hover-btn
                      cta-see-more cta-see-more-past
                    "
                    :style="{
                      '--primary-btn': $root.color_schema.primary_btn,
                      '--primary-btn-hover': pSBC(
                        -0.2,
                        $root.color_schema.primary_btn
                      ),
                    }"
                    >{{ $root.i18n.see_more }}</router-link
                  >
                </template>
              </div>
            </div>
          </template>
          <template v-if="$root.notSupportPageType === 'software'">
            <div
              class="col-lg-4"
              v-for="(data, index) in notSupportWidth < 576
                ? notsupportbannerData.best_available_data
                    .filter((ele) => ele.swr_review_link != null)
                    .slice(0, 2)
                : notsupportbannerData.best_available_data
                    .filter((ele) => ele.swr_review_link != null)
                    .slice(0, 4)"
              :key="index"
            >
              <div class="paymnt-card">
                <div class="paymnt-card-top">
                  <template v-if="$root.enable_piwik_reload">
                    <a
                      :title="data.name"
                      v-if="data"
                      :href="
                        getRouteLink(data.swr_review_link, $root.notSupportType)
                      "
                      class="pay-title software-title text-hover"
                    >
                      {{
                        getBPMGlobalString(
                          !data.remove_cascount &&
                            data.hasOwnProperty("toplist_count")
                            ? data.toplist_count
                            : "",
                          $root.i18n.casinos_are_supporting,
                          data.sw_name
                        )
                      }}</a
                    >
                  </template>
                  <template v-else>
                    <router-link
                      :title="data.name"
                      v-if="data"
                      :to="
                        getRouteLink(data.swr_review_link, $root.notSupportType)
                      "
                      class="pay-title software-title text-hover"
                    >
                      {{
                        getBPMGlobalString(
                          !data.remove_cascount &&
                            data.hasOwnProperty("toplist_count")
                            ? data.toplist_count
                            : "",
                          $root.i18n.casinos_are_supporting,
                          data.sw_name
                        )
                      }}</router-link
                    >
                  </template>
                  <div class="pay-logo">
                    <img
                      v-if="$root.enable_lazyload"
                      v-lazy="data.swa_url"
                      :alt="getAltText(data.sw_name, data.swa_url)"
                      width="105"
                      height="105"
                    />
                    <img
                      v-else
                      :src="data.swa_url"
                      :alt="getAltText(data.sw_name, data.swa_url)"
                      width="105"
                      height="105"
                    />
                  </div>
                </div>
                <template v-if="$root.enable_piwik_reload">
                  <a
                    :title="data.sw_name"
                    v-if="data"
                    :href="
                      getRouteLink(data.swr_review_link, $root.notSupportType)
                    "
                    class="
                      cta cta-primary cta-block cta-promotion
                      custom-btn
                      hover-btn
                      cta-see-more cta-see-more-past
                    "
                    :style="{
                      '--primary-btn': $root.color_schema.primary_btn,
                      '--primary-btn-hover': pSBC(
                        -0.2,
                        $root.color_schema.primary_btn
                      ),
                    }"
                    >{{ $root.i18n.see_more }}</a
                  >
                </template>
                <template v-else>
                  <router-link
                    :title="data.sw_name"
                    v-if="data"
                    :to="
                      getRouteLink(data.swr_review_link, $root.notSupportType)
                    "
                    class="
                      cta cta-primary cta-block cta-promotion
                      custom-btn
                      hover-btn
                      cta-see-more cta-see-more-past
                    "
                    :style="{
                      '--primary-btn': $root.color_schema.primary_btn,
                      '--primary-btn-hover': pSBC(
                        -0.2,
                        $root.color_schema.primary_btn
                      ),
                    }"
                    >{{ $root.i18n.see_more }}</router-link
                  >
                </template>
              </div>
            </div>
          </template>
        </div>
        <div
          class="text-right"
          v-if="
            notsupportbannerData.full_list_link &&
            notsupportbannerData.full_list_link != ''
          "
        >
          <a
            :title="$root.i18n.full_list"
            target="_blank"
            :rel="
              $root.change_cta_to_sponsored ? 'nofollow sponsored' : 'nofollow'
            "
            :href="notsupportbannerData.full_list_link"
            class="full-list"
            >{{ $root.i18n.full_list }}</a
          >
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import StarRating from "@/components/ui/StarRating";
import { pSBC, getContrastYIQ, getOffset } from "@/misc/misc-function";

export default {
  name: "NotSupportModal",
  props: ["notsupportbannerData", "relative"],
  data() {
    return {
      notSupportWidth: 0,
    };
  },
  components: {
    StarRating,
  },
  methods: {
    pSBC,
    getContrastYIQ,
    getOffset,
    closeModal: function () {
      this.$root.disableNotSupportBanner = false;
      this.$root.noScroll = false;
      this.$root.notSupportPageType = "";
      this.$root.notSupportType = "";
    },
    resetTitleHeight: function () {
      document.querySelectorAll(".software-title").forEach((ele) => {
        ele.style.height = "auto";
      });
      document.querySelectorAll(".payment-title").forEach((ele) => {
        ele.style.height = "auto";
      });
      if (this.notSupportWidth > 767) {
        document.querySelectorAll(".review-title").forEach((ele) => {
          ele.style.height = "auto";
        });
      }
    },
    updateBonusHeight: function () {
      let PaymenttitleHeight = 0;
      document.querySelectorAll(".payment-title").forEach((ele) => {
        if (ele.clientHeight > PaymenttitleHeight) {
          PaymenttitleHeight = ele.clientHeight;
        }
      });
      document.querySelectorAll(".payment-title").forEach((ele) => {
        ele.style.height = `${PaymenttitleHeight}px`;
      });

      let SoftwaretitleHeight = 0;
      document.querySelectorAll(".software-title").forEach((ele) => {
        if (ele.clientHeight > SoftwaretitleHeight) {
          SoftwaretitleHeight = ele.clientHeight;
        }
      });
      document.querySelectorAll(".software-title").forEach((ele) => {
        ele.style.height = `${SoftwaretitleHeight}px`;
      });
      if (this.notSupportWidth > 767) {
        let ReviewtitleHeight = 0;
        document.querySelectorAll(".review-title").forEach((ele) => {
          if (ele.clientHeight > ReviewtitleHeight) {
            ReviewtitleHeight = ele.clientHeight;
          }
        });
        document.querySelectorAll(".review-title").forEach((ele) => {
          ele.style.height = `${ReviewtitleHeight}px`;
        });
      }
    },
  },
  created() {
    this.notSupportWidth = window.innerWidth;
  },
  mounted() {
    this.$nextTick(() => {
      this.resetTitleHeight();
      this.updateBonusHeight();
      this.notSupportWidth = window.innerWidth;
    });
    window.addEventListener("resize", () => {
      this.resetTitleHeight();
      this.updateBonusHeight();
      this.notSupportWidth = window.innerWidth;
    });
  },
};
</script>
<style lang="less">
@import "~@/assets/less/base/variable";

.modal-wrap {
  width: calc(100% - 16px);
  z-index: 11;
  overflow: auto;
  margin: 0 8px;
  .border-radius(10px);

  &.is-relative {
    display: flex;
    justify-content: center;
  }

  @media (min-width: @sizes[medium]) {
    overflow: hidden;
  }
  @media (max-width: @sizes[small]) {
    display: flex;
    align-items: center;
  }

  &:not(.is-relative) {
    position: absolute;
    height: 100%;
    left: 0;
    top: 0;
    background: rgba(0, 0, 0, 0.85);

    .modal-body {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      @media (max-width: @sizes[medium]) {
        top: 10px;
        transform: translate(-50%, 0%);
        width: 100%;
      }
    }
  }

  .modal-body {
    .modal-header {
      position: relative;
      border-bottom: 0.5px solid @white;
      padding: 38px 0 8px;
      text-align: center;
      margin: 0 27.5px;
      @media (min-width: @sizes[medium]) {
        padding: 38px 0 10px;
        margin: 0;
      }
      p {
        font-family: Helvetica;
        font-weight: normal;
        font-size: 14px;
        line-height: 22px;
        color: @white;
        margin: 0;
        @media (min-width: @sizes[medium]) {
          font-size: 16px;
          line-height: 26px;
        }
      }
      .close-btn {
        background: transparent;
        border: 0;
        outline: 0;
        box-shadow: none;
        position: absolute;
        top: 0;
        left: 50%;
        cursor: default;
        -webkit-transform: translateX(-50%);
        -ms-transform: translateX(-50%);
        transform: translateX(-50%);
        min-width: 30px;
        @media (min-width: @sizes[medium]) {
          min-width: 35px;
        }
      }
    }
    .modal-cont {
      padding-top: 8px;
      margin: 0 15px;
      @media (min-width: @sizes[medium]) {
        padding-top: 10px;
      }
      .span-h4 {
        font-family: Helvetica;
        font-weight: bold;
        font-size: 16px;
        line-height: 26px;
        text-align: center;
        color: @white;
        margin-bottom: 8px;
        @media (min-width: @sizes[medium]) {
          font-size: 22px;
          line-height: 25px;
          margin-bottom: 18px;
        }
      }
      .text-right {
        text-align: center !important;
        @media (min-width: @sizes[medium]) {
          text-align: center !important;
        }
      }
      .full-list {
        display: inline-block;
        font-family: Helvetica;
        font-weight: normal;
        font-size: 16px;
        line-height: 26px;
        text-decoration: underline;
        color: @white;
        margin-top: 5px;
        &:hover {
          text-decoration: none;
        }
        @media (min-width: @sizes[medium]) {
          margin-bottom: 8px;
          padding-top: 10px;
        }
      }
      .row {
        &.payment-available {
          display: block;
          @media (min-width: @sizes[medium]) {
            .display-flex();
            .flex-wrap(nowrap);
            margin-top: 40px;
          }
          @media (min-width: @sizes[large]) {
            .display-flex();
            justify-content: center;
          }
          .col-sm-12 {
            width: 100%;
            @media (min-width: @sizes[medium]) {
              width: 25%;
            }
          }
        }
      }
    }
  }
}
.paymnt-card {
  width: 100%;
  min-width: 100%;
  background: @white;
  .border-radius(10px);
  padding: 10px;
  text-align: center;
  margin-bottom: 15px;
  @media (min-width: @sizes[medium]) {
    margin-bottom: 0;
    min-width: 158px;
    padding: 16px;
  }
  &-top {
    .display-flex();
    .align-items(flex-start);
    .justify-content-flex-start();
    .flex-direction-row();
    position: relative;
    margin-bottom: 6px;
    @media (min-width: @sizes[extra-small]) {
      .flex-direction-column();
      .align-items(center);
      .justify-content-center();
      margin-bottom: 0;
    }
    .pay-title {
      font-family: Helvetica;
      font-weight: bold;
      font-size: 12px;
      line-height: 14px;
      text-transform: uppercase;
      color: #222222;
      margin: 0 0 16px;
      display: block;
      text-align: left;
      -webkit-box-ordinal-group: 3;
      -ms-flex-order: 2;
      order: 2;
      @media (min-width: @sizes[extra-small]) {
        text-align: center;
        -webkit-box-ordinal-group: 2;
        -ms-flex-order: 1;
        order: 1;
      }
      span {
        display: block;
        @media (min-width: @sizes[extra-small]) {
          display: inline-block;
        }
      }
    }
    .pay-logo {
      display: block;
      margin-bottom: 6px;
      max-width: 47px;
      -webkit-box-ordinal-group: 2;
      -ms-flex-order: 1;
      order: 1;
      margin-right: 8px;
      @media (min-width: @sizes[extra-small]) {
        max-width: 74px;
        margin-bottom: 20px;
        -webkit-box-ordinal-group: 3;
        -ms-flex-order: 2;
        order: 2;
        margin-right: 0;
      }
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
  }
  .cta-see-more {
    padding: 8px;
    margin-top: 20px;
    font-family: Helvetica;
    font-weight: bold;
    font-size: 18px;
    line-height: 21px;
    background: #fe4646;
    border-color: #fe4646;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.2);
    display: flex;
    align-items: center;
    justify-content: center;
    .border-radius(5px);
    &:hover,
    &:focus {
      color: @white;
    }
    @media (min-width: @sizes[extra-small]) {
      display: flex;
      align-items: center;
      justify-content: center;
    }
    @media (min-width: @sizes[medium]) {
      padding: 8px;
      margin-top: 15px;
    }
    &-past {
      margin-top: 0;
      @media (min-width: @sizes[medium]) {
        margin-top: 15px;
      }
    }
  }
  &.cas-card {
    .paymnt-card-top {
      padding-left: 53px;
      margin-bottom: 10px;
      .flex-direction-row();
      .flex-wrap(wrap);
      position: relative;
      @media (min-width: @sizes[extra-small]) {
        padding-left: 0;
        .align-items(center);
        .justify-content-center();
        margin-bottom: 0;
      }
      @media (min-width: @sizes[medium]) {
        .flex-direction-column();
        .flex-wrap(nowrap);
      }
    }
    .pay-title {
      margin-bottom: 6px;
      -webkit-box-ordinal-group: 3;
      -ms-flex-order: 2;
      order: 2;
      width: 100%;
      @media (min-width: @sizes[medium]) {
        margin-bottom: 12px;
        -webkit-box-ordinal-group: 2;
        -ms-flex-order: 1;
        order: 1;
        width: auto;
      }
    }
    .pay-logo {
      margin-bottom: 0px;
      margin-right: 0;
      max-width: 37px;
      height: 37px;
      .border-radius(5px);
      -webkit-box-ordinal-group: 2;
      -ms-flex-order: 1;
      order: 1;
      img {
        .border-radius(5px);
      }
      position: absolute;
      left: 0;
      top: 0;
      @media (min-width: @sizes[extra-small]) {
        position: static;
        margin-bottom: 10px;
      }
      @media (min-width: @sizes[medium]) {
        margin-bottom: 12px;
        max-width: 57px;
        height: 57px;
        -webkit-box-ordinal-group: 3;
        -ms-flex-order: 2;
        order: 2;
      }
    }
    .rating-wrapper {
      margin-bottom: 0px !important;
      -webkit-box-ordinal-group: 4;
      -ms-flex-order: 3;
      order: 3;
      @media (min-width: @sizes[extra-small]) {
        margin-bottom: 24px;
      }
      .rating-stars {
        padding-right: 0;
      }
      .rating-star-total {
        line-height: 1;
      }
    }
  }
}

.pay-soft-modal {
  @media (min-width: @sizes[medium]) {
    margin: 8px auto 20px auto !important;
  }
  .modal-header {
    padding: 38px 0 8px !important;
  }
  .modal-cont {
    padding-top: 8px !important;
    .row.payment-available {
      margin-top: 12px !important;
      .pay-logo {
        margin-bottom: 0px !important;
      }
      .paymnt-card-top {
        align-items: center !important;
        a {
          margin-bottom: 0px !important;
          @media (max-width: @sizes[small]) {
            margin-bottom: 0px !important;
            display: flex !important;
            align-items: center !important;
          }
        }
      }
    }
    .span-h4 {
      margin-bottom: 0px !important;
    }
    .full-list {
      margin-top: 2px !important;
      @media (min-width: @sizes[large]) {
        padding-top: 10px !important;
      }
    }
  }
}

.center-text {
  margin: 150px auto !important;
  .modal-header {
    border-bottom: 0px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/custom-block/NotSupportModal.vue